// Country dialling codes for the astrologer's contact phone.
// iso = ISO 3166-1 alpha-2 (for flag images via flagcdn.com).
export const COUNTRY_CODES = [
  { code: '+852', iso: 'hk', name: '香港' },
  { code: '+853', iso: 'mo', name: '澳門' },
  { code: '+86', iso: 'cn', name: '中國' },
  { code: '+886', iso: 'tw', name: '台灣' },
  { code: '+65', iso: 'sg', name: '新加坡' },
  { code: '+60', iso: 'my', name: '馬來西亞' },
  { code: '+1', iso: 'us', name: '美國／加拿大' },
  { code: '+44', iso: 'gb', name: '英國' },
  { code: '+61', iso: 'au', name: '澳洲' },
  { code: '+81', iso: 'jp', name: '日本' },
  { code: '+82', iso: 'kr', name: '韓國' },
  { code: '+66', iso: 'th', name: '泰國' },
  { code: '+63', iso: 'ph', name: '菲律賓' },
];
